/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Pick_EmailInputs */



/**
* | output |
* | --- |
* | "Choose the column that holds email addresses to see a preview." |
*
* @param {Team_Manager_Import_Pick_EmailInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_pick_email = /** @type {((inputs?: Team_Manager_Import_Pick_EmailInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Pick_EmailInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez la colonne des adresses e-mail pour afficher un aperçu.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie die Spalte mit den E-Mail-Adressen, um eine Vorschau zu sehen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scegli la colonna con gli indirizzi email per vedere un'anteprima.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите столбец с адресами почты, чтобы увидеть предпросмотр.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Elige la columna con los correos para ver una vista previa.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择包含电子邮件地址的列以查看预览。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メールアドレスの列を選ぶとプレビューが表示されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पूर्वावलोकन देखने के लिए ईमेल पते वाला कॉलम चुनें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Escolha a coluna com os endereços de email para ver uma pré-visualização.")
	return /** @type {LocalizedString} */ ("Choose the column that holds email addresses to see a preview.")
});